import * as ActionTypes from './ActionTypes'
import uuidv4 from 'uuid/v4'
import { getCurrentOrder, getCurrentOrderUuid } from './Selectors'
import { VNORDERS_STATES } from './Enums'
import { getIsKiosk } from '../selectors/menus'
import { getOrder } from '../selectors/order'
import { STADIUM_ORDER_STATES } from '../utils/orderStates'
import { cancelOrder } from '../actions/order'
import { currentOrderUuid } from '../utils/orderNumbers'

export function createOrder() {
  return (dispatch, getState) => {
    // if current order never synced to the server, we can just clear and re-use
    const currentOrder = getCurrentOrder(getState())

    if (currentOrder && currentOrder.get('orderState') === VNORDERS_STATES.LOCAL) {
      dispatch(
        updateOrder({
          uuid: currentOrder.get('uuid'),
          orderState: VNORDERS_STATES.LOCAL,
        }),
      )
    } else {
      const currentOrderUuid = uuidv4()

      dispatch({
        type: ActionTypes.VNORDERS_SET_CURRENT_ORDER_UUID,
        orderUuid: currentOrderUuid,
      })

      dispatch(
        updateOrder({
          uuid: currentOrderUuid,
          orderState: VNORDERS_STATES.LOCAL,
        }),
      )
    }
  }
}

export function clearCurrentOrder(clearFullOrder = false) {
  return (dispatch, getState) => {
    // get the current order uuid in state
    const currentOrderUuid = getCurrentOrderUuid(getState())

    if (clearFullOrder) {
      dispatch({
        type: ActionTypes.VNORDERS_UNSET_ORDER,
        order: {
          uuid: currentOrderUuid,
        },
      })
    }

    // empty out the current order in state
    dispatch({
      type: ActionTypes.VNORDERS_SET_CURRENT_ORDER_UUID,
      orderUuid: '',
    })
  }
}

export function updateOrder(order) {
  return (dispatch, getState) => {
    // update full order in state
    dispatch({
      type: ActionTypes.VNORDERS_SET_ORDER,
      order,
    })
  }
}

export function deleteOrder(orderUuid) {
  return (dispatch, getState) => {
    // Remove from orders Map
    dispatch({
      type: ActionTypes.VNORDERS_UNSET_ORDER,
      order: {
        uuid: orderUuid,
      },
    })

    // remove in unsyncedOrders as well
    dispatch({
      type: ActionTypes.VNORDERS_UNSET_UNSYNCED_ORDER,
      order: {
        uuid: orderUuid,
      },
    })
  }
}

export function addUnsyncedOrder(orderUuid) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNORDERS_SET_UNSYNCED_ORDER,
      order: {
        uuid: orderUuid,
      },
    })
  }
}

export function removeUnsyncedOrder(orderUuid) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNORDERS_UNSET_UNSYNCED_ORDER,
      order: {
        uuid: orderUuid,
      },
    })
  }
}

export function startOrderAction(pAction, pParams) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNORDERS_SET_ORDER_ACTION,
      orderAction: {
        action: pAction,
        params: pParams,
      },
    })
  }
}

export function addTempPaymentToOrder(payment) {
  return (dispatch, getState) => {
    const currentOrderUuid = getCurrentOrderUuid(getState())

    dispatch({
      type: ActionTypes.VNORDERS_SET_TEMP_PAYMENT,
      orderUuid: currentOrderUuid,
      payment,
    })
  }
}

export function setShouldIncrementOrderNumber() {
  return (dispatch, getState) => {
    const state = getState()
    const isKiosk = getIsKiosk(state)

    if (isKiosk) return

    const currentOrderId = state.order?.currentOrderId ?? currentOrderUuid()
    const curOrder = getOrder(state, currentOrderId)

    if (curOrder?.state === STADIUM_ORDER_STATES.SUBMITTED || curOrder?.state === STADIUM_ORDER_STATES.AUTHORIZATION_FAILED) {
      dispatch(cancelOrder(currentOrderId, 'User cleared the cart.'))
      dispatch({ type: ActionTypes.VNORDERS_INCREMENT_ORDER_NUMBER })
      return
    }

    dispatch({ type: ActionTypes.VNORDERS_SAME_ORDER_NUMBER })
  }
}
